export default "__VITE_ASSET__BBU5D_HV__"